<template>
    <header>
        <p class="app-title">
            <img
                :src="require('@img/' + config.logo).default"
                v-if="config.logo"
            />
            <span v-else>
                {{ config.title }}
            </span>
        </p>

        <nav class="header-actions">
            <Link href="/logout" role="button">Logout</Link>
        </nav>
    </header>

    <div class="container-content">
        <aside class="side-nav">
            <Nav
                :controller="request_params.controller"
                :action="request_params.action"
            />
        </aside>

        <main>
            <div id="breadcrumbs" data-slot="breadcrumbs"></div>
            <section class="container-main-content">
                <slot />
            </section>
        </main>
    </div>
</template>

<script setup>
import { Inertia } from "@inertiajs/inertia";
import Nav from "@inertia/Layout/Nav";

const props = defineProps({
    request_params: Object,
});

Inertia.on("navigate", (event) => {
    document.body.setAttribute(
        "data-controller",
        props.request_params.controller
    );

    document.body.setAttribute("data-action", props.request_params.action);
});
</script>

<style lang="scss" scoped></style>
